import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, useEffect } from 'react';
import { TabContext, TabPanel, } from '@mui/lab';
import { Tab, Box, Tabs, } from '@mui/material';
/** Local styles */
const styles = {
    container: {
        width: '100%',
        textAlign: 'left',
    },
    resultContent: {
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0.015625rem',
        textAlign: 'left',
    },
    resultContainer: {
        padding: '1.5rem 0',
        margin: '1.5rem 0',
        background: 'linear-gradient(0deg, rgba(0, 107, 84, 0.11), rgba(0, 107, 84, 0.11)), #FAFAFA',
        borderRadius: '1.75rem',
    },
    tabLabel: {
        fontWeight: '500',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        textAlign: 'center',
        letterSpacing: '0.00625rem',
        textTransform: 'none',
        padding: '0.875rem 0',
        margin: '0',
        color: '#404943',
        width: '50%',
    },
    tabContainer: {
        borderBottom: 1,
        borderColor: 'divider',
        display: 'inline-block',
        margin: '0 0 1.5rem',
        maxWidth: '22.5rem',
        width: '100%',
    },
};
;
/**
 * Customized Tabs
 * @param {any} props
 * @returns {<Box>}
 */
export function TabsSG(props) {
    const { tabs, activeTab } = props;
    const [value, setValue] = useState(activeTab || '0');
    // Initialize active tab when it's loaded
    useEffect(() => {
        if (activeTab) {
            setValue(activeTab);
        }
    }, [activeTab]);
    /**
     * Handle Tab changed
     * @param {SyntheticEvent} event
     * @param {string} newValue
     * @returns {void}
     */
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (_jsx(Box, Object.assign({ sx: styles.container }, { children: _jsxs(TabContext, Object.assign({ value: value }, { children: [_jsx(Box, Object.assign({ sx: styles.tabContainer }, { children: _jsx(Tabs
                    // Customized Tabs
                    , Object.assign({ 
                        // Customized Tabs
                        onChange: handleChange, "aria-label": "Tab", value: value, sx: {
                            width: '100%',
                        }, TabIndicatorProps: {
                            style: {
                                backgroundColor: '#006B54',
                            }
                        } }, { children: tabs.map((tab, idx) => (_jsx(Tab, { sx: styles.tabLabel, label: tab.label, value: `${idx}` }, tab.label))) })) })), tabs.map((tab, idx) => (_jsx(TabPanel, Object.assign({ value: `${idx}`, sx: { padding: '0' } }, { children: tab.component }), tab.label)))] })) })));
}
;
